<template>
	<div style="margin: 0 auto;">
		<div style="font-size: 30px; padding: 10px 0;">{{ $route.meta.title }}</div>
		<div style="padding:6px 15px; ">
			<Form ref="searchForm" :model="searchForm" label-position="left" :label-width="70" inline>
				<FormItem label="手机号码"><Input type="text" v-model="searchForm.mobile" placeholder="手机号码" /></FormItem>
				<FormItem label="姓名"><Input type="text" v-model="searchForm.name" placeholder="姓名" /></FormItem>
				<FormItem label="帐号状态">
					<Select v-model="searchForm.state" clearable>
						<Option value="1">正常</Option>
						<Option value="0">无效</Option>
					</Select>
				</FormItem>
				<FormItem label="服务站点">
					<Select v-model="searchForm.jcz" clearable>
						<Option value="0">未使用</Option>
						<Option value="1">已使用</Option>
					</Select>
				</FormItem>
				<FormItem label="接单状态">
					<Select v-model="searchForm.jdstate" clearable>
						<Option value="0">停止接单</Option>
						<Option value="1">接单中</Option>
					</Select>
				</FormItem>
				<FormItem label="身份认证">
					<Select v-model="searchForm.rz_idcard" clearable>
						<Option value="0">未认证</Option>
						<Option value="1">已认证</Option>
					</Select>
				</FormItem>
				<FormItem label="驾照认证">
					<Select v-model="searchForm.rz_jiazhao" clearable>
						<Option value="0">未认证</Option>
						<Option value="1">已认证</Option>
					</Select>
				</FormItem>
				<FormItem>
					<Button type="primary" @click="handleSubmit('searchForm')">
						<Icon type="ios-search" />
						搜索
					</Button>
				</FormItem>
			</Form>
		</div>
		<Table :data="tableData2" :columns="tableColumns2" size="large" border :loading="loading" header="header" footer="footer">
			<template slot-scope="{ row }" slot="state">
				<Tag color="success" v-if="row.stateflag == '1'">正常</Tag>
				<Tag color="error" v-else>无效</Tag>
			</template>
			<template slot-scope="{ row }" slot="rz_idcard">
				<Icon color="#19be6b" type="md-checkmark-circle-outline" v-if="row.rz_idcard==1" />
			</template>
			<template slot-scope="{ row }" slot="rz_jiazhao">
				<Icon color="#19be6b" type="md-checkmark-circle-outline" v-if="row.rz_jiazhao==1" />
			</template>
			<template slot-scope="{ row }" slot="jdstate">
				<Tag color="green" v-if="row.jdstate == '1'">正常接单</Tag>
				<Tag color="default" v-else>停止接单</Tag>
			</template>
			<template slot-scope="{ row }" slot="action">
				<router-link tag="a" :to="{ path: 'view/'+row.uid }">
					<Button type="primary">
						查看
					</Button>
				</router-link>
			</template>
			

			<template slot="header">
				<div class="flex justify-between">
					<div span="12">
					</div>
					<div span="12">
						<div style="text-align: right;">
							<Page :total="searchForm.total" :page-size="searchForm.size" :current="searchForm.page" @on-change="pageChange"
							 :show-total="true" :show-sizer="true" @on-page-size-change="pageSizeChange"></Page>
						</div>
					</div>
				</div>

			</template>
			<template slot="footer">
				<div style="text-align: right;">
					<Page :total="searchForm.total" :page-size="searchForm.size" :current="searchForm.page" @on-change="pageChange"
					 :show-total="true" :show-sizer="true" @on-page-size-change="pageSizeChange"></Page>
				</div>
			</template>
		</Table>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				jczList: [],
				loading: false,
				tableColumns2: [{
						title: 'id',
						type: 'index',
						width: 58
					},
					{
						title: '姓名',
						align: 'center',
						key: 'nickname',
						width: 150
					},
					{
						title: '手机号',
						key: 'mobile',
						align: 'center',
						width: 150
					},
					{
						title: '帐号状态',
						slot: 'state',
						align: 'center',
						width: 110
					},
					{
						title: '身份认证',
						slot: 'rz_idcard',
						align: 'center',
						width: 110
					},
					{
						title: '驾照认证',
						slot: 'rz_jiazhao',
						align: 'center',
						width: 110
					},
					{
						title: '服务站点',
						align: 'center',
						key: 'jcz'
					},
					{
						title: '接单状态',
						slot: 'jdstate',
						align: 'center',
						width: 110
					},
					{
						title: '订单情况',
						key: 'order',
						align: 'center',
						width: 110
					},
					{
						title: '服务评分',
						key: 'rate',
						align: 'center',
						width: 110
					},
					{
						title: '注册时间',
						key: 'addtime',
						align: 'center',
						width: 190
					},
					{
						title: '操作',
						slot: 'action',
						align: 'center',
						width: 120
					}
				],
				tableData2: [],
				searchForm: {
					page: 1,
					size: 20,
					total: 0,
					mobile: '',
					name: '',
					state: '',
					jcz: '',
					jdstate: '',
					rz_idcard: '',
					rz_jiazhao: ''
				}
			};
		},
		methods: {
			handleSubmit(name) {
				this.loadinfos();
				return false;
			},
			loadinfos() {
				var that = this;
				this.loading = true;
				this.$http.post('/server/api/sf/user/index.php?a=list', this.$qs.stringify(this.searchForm)).then(
					res => {
						this.loading = false;
						if (res.data.result == 'ok') {
							//this.$Message.success('获取成功!');
							this.searchForm.total = res.data.data.total;
							this.tableData2 = res.data.data.infos;
						} else {
							this.$Message.error(res.data.msg);
						}
					},
					r => {
						this.loading = false;
						this.$Message.error('系统错误');
					}
				);
			},
			pageChange(page) {
				this.searchForm.page = page;
				this.loadinfos();
			},
			pageSizeChange(size) {
				this.searchForm.size = size;
				this.loadinfos();
			}
		},
		created() {
			this.loadinfos();
		}
	};
</script>

<style>
.demo-spin-icon-load{
	font-size:5em;
        animation: ani-demo-spin 1s linear infinite;
    }
</style>
